import React, {useEffect, useState} from "react";
import Layout from "../../layout/Layout/Layout";
import {Box} from "@mui/material";
import {DataGrid, GridCellParams} from "@mui/x-data-grid";
import axios from "axios";
import 'react-responsive-modal/styles.css';
import {Modal} from 'react-responsive-modal';
import {toast} from "react-toastify";
import Loader from "../loader/loader";
import {APP_CONFIGURATION} from "../../app-config/configuration";


interface User {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    videoPath: string | null;
    createdAt: string; // ISO Date string
    rememberMe: boolean;
    ipAddress: string;
    geoLocation: string;
    termsAcceptanceText: string;
    fullName: string | null;
    age: string; // Age as string
    gender: string | null;
    emailAddress: string | null;
    phoneNumber: string | null;
    countryCode: string | null;
    country: string | null;
    postalCode: string | null;
    state: string | null;
    city: string | null;
    streetAddress: string | null;
    nationality: string | null;
    hasInvestedInStockMarket: boolean;
    investmentsMade: string | null;
    investmentExperience: string | null;
    whyJoinIndiaFutureInvestors: string | null;
    referralSource: string | null;
    ageProofDocument: string | null;
    profilePicture: string | null;
    registrationDate: string; // ISO Date string
    referralCode: string;
    referredByCode: string;
    referralStage: string;
    message: string | null;
    formStatus: boolean;
    mobileVerified: boolean;
}


const RegistrationList = () => {
    const [blogData, setBlogData] = useState<User[]>([]);
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState<string>()
    const [loading, setLoading] = useState<boolean>(false)

    const onOpenModal = (id: any) => {
        setOpen(true);
        setDeleteId(id)
    }
    const onCloseModal = () => setOpen(false);

    const handleDelete = () => {
        const payload = {
            id: deleteId
        }
        setLoading(true)
        // @ts-ignore
        axios.post(`${APP_CONFIGURATION.APP_CONSTANT.API_URL}api/v0/deleteBlog`, payload, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
            .then((res) => {
                if (res.status) {
                    setLoading(false)
                    toast.success("Deleted Successfully");
                    onCloseModal()
                    getAllBlog()
                }
            })
            .catch((err) => {
                // Handle the error
            });
    }
    const handleEdit = (id: string) => {
        window.location.replace(`/create-blog/${id}`);
    }
    const columns = [
        {
            field: "srNo",
            headerName: "Sr. No.",
            width: 60,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as number}</div>
            ),
        },
        {
            field: "fullName",
            headerName: "Full Name",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "email",
            headerName: "Email Address",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "phoneNumber",
            headerName: "Phone Number",
            width: 150,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "geoLocation",
            headerName: "Geo Location",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "age",
            headerName: "Age",
            width: 100,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "gender",
            headerName: "Gender",
            width: 120,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "Not Specified"}</div>
            ),
        },
        {
            field: "country",
            headerName: "Country",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "state",
            headerName: "State",
            width: 150,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "city",
            headerName: "City",
            width: 150,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "hasInvestedInStockMarket",
            headerName: "Stock Market Investor",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value ? "Yes" : "No"}</div>
            ),
        },
        {
            field: "investmentsMade",
            headerName: "Investments Made",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "investmentExperience",
            headerName: "Investment Experience",
            width: 300,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string || "N/A"}</div>
            ),
        },
        {
            field: "referralCode",
            headerName: "Referral Code",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value as string}</div>
            ),
        },
        {
            field: "registrationDate",
            headerName: "Registration Date",
            width: 200,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{new Date(params.value as string).toLocaleDateString()}</div>
            ),
        },
        {
            field: "formStatus",
            headerName: "Form Status",
            width: 150,
            renderCell: (params: GridCellParams) => (
                <div style={{ textAlign: 'center' }}>{params.value ? "Completed" : "Incomplete"}</div>
            ),
        },
    ];





    useEffect(() => {
        getAllBlog()
    }, []);
    const getAllBlog = () => {
        setLoading(true)
        axios
            .get(`https://gatewayapi-uat.worldtradingleagues.com/api/v1/ifi/all-registered-data`)
            .then((res) => {
                console.log('res' , res.data)
                const blogDataWithKeys = res.data.map((item: User, index: number) => ({
                    ...item,
                    id: item.id.toString(),
                    srNo: index + 1, // Add a new property for Sr. No.
                }));
                setBlogData(blogDataWithKeys);
                setLoading(false)
            })
            .catch(() => {
            });
    }

    // @ts-ignore
    return (
        <>
            <Layout>
                <main id="main" className="main">
                    <div className="pagetitle mt-3">
                        <h1>Registration</h1>
                        <nav>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    Home
                                </li>
                                <li className="breadcrumb-item active">Registration</li>
                            </ol>
                        </nav>
                    </div>
                    <section className="section dashboard">
                        <Loader loading={loading}/>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 mt-5">
                                    <Box>
                                        <DataGrid
                                            rows={blogData}
                                            columns={columns}
                                            pagination
                                            // rowCount={blogData.length}
                                            // pageSizeOptions={[10, 15, 25]}
                                        />
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <Modal open={open} onClose={onCloseModal} center>
                    <div className='p-5 text-center'>
                        <h3>Are You Sure You Want to Delete?</h3>
                        <div className="mt-3">
                            <button className="btn btn-danger ml-5" onClick={handleDelete}>Yes</button>
                            <button className="btn btn-secondary mr-4" style={{marginLeft: '10px'}}
                                    onClick={onCloseModal}>Cancel
                            </button>
                        </div>
                    </div>
                </Modal>
            </Layout>
        </>
    );
};

export default RegistrationList;
